import React from "react";
import { View } from "react-native";

import { useOtherTextResponse } from "screens/question/hooks";
import { Input } from "components";
import { styles } from "./styles";
import { QuestionKind } from "consts";
import { isValidName } from "utils";

export const TextInputQuestion = props => {
  const { value, placeholder, onChange } = useOtherTextResponse(props.question);
  const isNameKind = props.question.kind === QuestionKind.NAME;
  return (
    <View style={styles.container}>
      <Input
        value={value}
        maxLength={(isNameKind && 100) || 1000}
        onChangeText={txt => {
          if (!(isNameKind && isValidName(txt))) {
            return onChange(txt);
          }
        }}
        placeholder={placeholder}
      />
    </View>
  );
};
